import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useUpdateLcrWorksheetMacro = (
  crId, lcrId, worksheetId,
) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useMutation(
    ({ liveCleanRoomWorksheetMacroID, macroData }) => (
      axiosInstance.put(liveCleanroom(orgId)
        .updateWorksheetMacro(crId, lcrId, worksheetId, liveCleanRoomWorksheetMacroID),
      macroData)
    ),
    {
      onSuccess: () => {
        dispatch(
          showAlert({
            message: 'Macro updated successfully',
            type: 'success',
          }),
        );
      },
      onError: (error) => {
        dispatch(
          showAlert({
            message: error.response?.data?.message || 'Error updating macro',
            type: 'error',
          }),
        );
      },
    },
  );
};
